import { combineReducers } from 'redux';
import templatesReducer from './templatesReducer';
import helpReducer from './helpReducer';

export const rootReducer = combineReducers({
  templates: templatesReducer,
  help: helpReducer,
});

export type RootState = ReturnType<typeof rootReducer>